import React from 'react';
import cx from 'classnames';

import { GiftGroupIcon } from '../../SvgIconsV3/GiftGroup';
import styles from './groupGiftTag.module.less';

export const GroupGiftTag = ({ className }: { className?: string }) => {
  return (
    <div className={cx(styles.groupGiftTagWrapper, className)}>
      <div className={styles.groupGiftTag}>
        <GiftGroupIcon showTitle={false} height={14} width={14} />
        <span>Group gift contribution</span>
      </div>
    </div>
  );
};
